// Search routines
import $ from 'jquery';
import * as Site from "../js/site";
import * as Constants from "./constants";

export const initSearch = () => {
  console.log("Search->initSearch");
  //****For testing****
  // $("#main-apn-input").val("2580904300");
  // $("#main-address-input").val("505 S Vulcan ave");
  //************
}

export const findParcelByAPN = () => {
  let apn = $.trim($("#main-apn-input").val());
  let addr = $.trim($("#main-address-input").val());
  console.log("Search->findParcelByAPN: " + apn + ", " + addr);
  Site.displayMessage("#main-search-parcel", "Searching for parcel...");
  return { apn: apn, addr: addr };
};

export function buildParcelHtml(attr) {
  let addr = attr.SitusStreet === "Null" ? "" : attr.SitusStreet;
  $("#map-identify-apn").html(attr.APN);
  $("#map-identify-address").html(addr);
  //return `<strong>APN:</strong> ${attr.APN}<span>Zoom to Parcel</span><br /><strong>Address:</strong> ${addr}`;
}

export function buildZoningHtml(attr) {
  let url = attr.URL === "Null" ? "" : '<a href="' + attr.URL + '" target="_blank">Click to View</a>';
  // <strong>Designation:</strong> ${ attr["Zone Designation"] === "Null" ? "" : attr["Zone Designation"] } <br />
  return `<strong>Zoning Code:</strong> ${attr["Zonecode"] === "Null" ? "" : attr["Zonecode"]}<br />
    <strong>Description:</strong> ${attr.Description === "Null" ? "" : attr.Description}<br />
    <strong>Reference:</strong> ${attr.Reference === "Null" ? "" : attr.Reference}<br />
    <strong>Parking:</strong> ${attr.Parking === "Null" ? "" : attr.Parking}<br />
    <strong>Plan Code:</strong> ${attr["Specific Plan Code"] === "Null" ? "" : attr["Specific Plan Code"]}<br />
    <strong>Plan Name:</strong> ${attr[" Specific Plan Name"] === "Null" ? "" : attr[" Specific Plan Name"]}<br />
    <strong>Width:</strong> ${attr.WidthFeet === "Null" ? "" : attr.WidthFeet}<br />
    <strong>Depth:</strong> ${attr.DepthFeet === "Null" ? "" : attr.DepthFeet}<br />
    <strong>Height:</strong> ${attr.Height === "Null" ? "" : attr.Height}<br />
    <strong>Front Setback:</strong> ${attr.FrontSetback === "Null" ? "" : attr.FrontSetback}<br />
    <strong>Rear Setback:</strong> ${attr.RearYardSetback === "Null" ? "" : attr.RearYardSetback}<br />
    <strong>Street Side Setback:</strong> ${attr.StreetSideYardSetback === "Null" ? "" : attr.StreetSideYardSetback}<br />
    <strong>Interior Side Setback:</strong> ${attr.InteriorSideYardSetback === "Null" ? "" : attr.InteriorSideYardSetback}<br />
    <strong>Net Lot Area Square Feet:</strong> ${attr.NetLotAreaSquareFeet === "Null" ? "" : attr.NetLotAreaSquareFeet}<br />
    <strong>Floor Area Ratio:</strong> ${attr.FloorAreaRatio === "Null" ? "" : attr.FloorAreaRatio}<br />
    <strong>Midrange Density:</strong> ${attr.MidrangeDensity === "Null" ? "" : attr.MidrangeDensity}<br />
    <strong>Maximum Density:</strong> ${attr.MaximumDensity === "Null" ? "" : attr.MaximumDensity}<br />
    <strong>Lot Coverage Percent:</strong> ${attr.LotCoveragePercent === "Null" ? "" : attr.LotCoveragePercent}<br />
    <strong>Landscaping Percent:</strong> ${attr.LandscapingPercent === "Null" ? "" : attr.LandscapingPercent}<br />
    <strong>Footnote:</strong> ${attr.Footnote === "Null" ? "" : attr.Footnote}`;
}

export function buildAdditionalZonesHtml(results, infoDiv, overlayZones) {
  let prevLayerId = 0;
  // results.sort((a, b) => a.layerId - b.layerId);
  results.sort((a, b) => a.layerName - b.layerName);
  infoDiv.empty();

  for (let idx = 0; idx < results.length; idx++) {
    console.log(results[idx].layerId + " - " + results[idx].layerName + ": " + results[idx].feature.attributes.ZoneDesignation);
    if (results[idx].layerId === prevLayerId) continue;

    prevLayerId = results[idx].layerId;
    let ozInfo = Constants.overlayZoneInfo;
    for (let ozIdx = 0; ozIdx < ozInfo.length; ozIdx++) {
      if (ozInfo[ozIdx].layerId === prevLayerId) {
        overlayZones[ozIdx].inZone = "Yes";
        let a = $("<a />", {
          href: ozInfo[ozIdx].url,
          target: "_blank",
          text: ozInfo[ozIdx].name
        });
        let div = $("<div />");
        div.append(a);
        infoDiv.append(div);
        break;
      }
    }
  }
}
